import * as React from 'react';
const DarkThemeButton = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="#6284FF"
    />
    <path
      d="M14.7525 9.64762C14.1049 9 13.1906 8.58095 12.2001 8.58095C11.2096 8.58095 10.2953 8.98095 9.64772 9.64762C9.0001 10.2952 8.58105 11.2095 8.58105 12.2C8.58105 13.1905 9.0001 14.1048 9.64772 14.7524C10.2953 15.4 11.2096 15.8191 12.2001 15.8191C13.1906 15.8191 14.1049 15.4191 14.7525 14.7524C15.4001 14.1048 15.8192 13.1905 15.8192 12.2C15.8192 11.2095 15.4192 10.2952 14.7525 9.64762ZM14.0668 14.0667C13.5906 14.5429 12.9239 14.8286 12.2001 14.8286C11.4763 14.8286 10.8096 14.5429 10.3334 14.0667C9.85725 13.5905 9.57153 12.9238 9.57153 12.2C9.57153 11.4762 9.85725 10.8095 10.3334 10.3333C10.8096 9.85714 11.4763 9.57143 12.2001 9.57143C12.9239 9.57143 13.5906 9.85714 14.0668 10.3333C14.543 10.8095 14.8287 11.4762 14.8287 12.2C14.8287 12.9238 14.543 13.5905 14.0668 14.0667Z"
      fill="white"
    />
    <path
      d="M18.9045 11.7048H17.4379C17.1712 11.7048 16.9426 11.9333 16.9426 12.2C16.9426 12.4667 17.1712 12.6952 17.4379 12.6952H18.9045C19.1712 12.6952 19.3998 12.4667 19.3998 12.2C19.3998 11.9333 19.1712 11.7048 18.9045 11.7048Z"
      fill="white"
    />
    <path
      d="M12.2001 16.9429C11.9334 16.9429 11.7048 17.1714 11.7048 17.4381V18.9048C11.7048 19.1714 11.9334 19.4 12.2001 19.4C12.4667 19.4 12.6953 19.1714 12.6953 18.9048V17.4381C12.6953 17.1714 12.4667 16.9429 12.2001 16.9429Z"
      fill="white"
    />
    <path
      d="M17.2856 16.6L16.238 15.5524C16.0666 15.3619 15.7428 15.3619 15.5523 15.5524C15.3618 15.7429 15.3618 16.0476 15.5523 16.2381L16.5999 17.2857C16.7904 17.4762 17.0951 17.4762 17.2856 17.2857C17.4761 17.0952 17.4761 16.7905 17.2856 16.6Z"
      fill="white"
    />
    <path
      d="M12.2001 5C11.9334 5 11.7048 5.22857 11.7048 5.49524V6.96191C11.7048 7.22857 11.9334 7.45715 12.2001 7.45715C12.4667 7.45715 12.6953 7.22857 12.6953 6.96191V5.49524C12.6953 5.22857 12.4667 5 12.2001 5Z"
      fill="white"
    />
    <path
      d="M17.3049 7.11428C17.1144 6.9238 16.8097 6.9238 16.6192 7.11428L15.5716 8.1619C15.3811 8.35237 15.3811 8.65714 15.5716 8.84761C15.743 9.03809 16.0668 9.03809 16.2573 8.84761L17.3049 7.79999C17.4954 7.60952 17.4954 7.30475 17.3049 7.11428Z"
      fill="white"
    />
    <path
      d="M6.96191 11.7048H5.49524C5.22857 11.7048 5 11.9333 5 12.2C5 12.4667 5.20952 12.6952 5.49524 12.6952H6.96191C7.22857 12.6952 7.45715 12.4667 7.45715 12.2C7.45715 11.9333 7.22857 11.7048 6.96191 11.7048Z"
      fill="white"
    />
    <path
      d="M8.82858 15.5524C8.65716 15.3619 8.33335 15.3619 8.14287 15.5524L7.09525 16.6C6.90477 16.7905 6.90477 17.0952 7.09525 17.2857C7.28573 17.4762 7.59049 17.4762 7.78096 17.2857L8.82858 16.2381C9.01906 16.0476 9.01906 15.7429 8.82858 15.5524Z"
      fill="white"
    />
    <path
      d="M8.82858 8.1619L7.78096 7.11428C7.59049 6.9238 7.28573 6.9238 7.09525 7.11428C6.90477 7.30475 6.90477 7.60952 7.09525 7.79999L8.14287 8.84761C8.33335 9.03809 8.63811 9.03809 8.82858 8.84761C9.01906 8.65714 9.01906 8.35237 8.82858 8.1619Z"
      fill="white"
    />
  </svg>
);
export default DarkThemeButton;
